import React from 'react';
import {StatusSelectValueProps} from '../../Filters/StatusSelect';
import {SelectedBooleanStatusType} from "../../Filters/utils";
import StatusSelectMonitoring from "./StatusSelectMonitoring";

const DANGER_MODE_STATUS = {
    true: 'Опасное явление',
    false: 'Не опасное явление',
    unknown: 'Явление: Неизвестно',
};

export function DangerModeStatusSelectMonitoring(props: StatusSelectValueProps<SelectedBooleanStatusType>) {
    return (
        <StatusSelectMonitoring
            {...props}
            statusDescription={DANGER_MODE_STATUS}
            allValuesLabel="Все явления"
        />
    );
}
export default DangerModeStatusSelectMonitoring;